import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { Button, CircularProgress } from "@nextui-org/react";
import { useGlobalData } from "@/contexts/GlobalData";
import LottieAnimation from "../LottieAnimation";
import getAnimation from "@/common/function/getAnimation";
import { forwardRef } from "react";
export type ButtonStatus = "normal" | "disabled" | "loading" | "processing" | "error" | "success";
interface GradientButtonPropsType extends GeneralPropsType {
  status: ButtonStatus;
  statusKey: string;
}
function GradientButton({
  children,
  className,
  status = "normal",
  statusKey,
  ...rest
}: GradientButtonPropsType | any, ref: any) {
  const {
    translate
  } = useGlobalData();
  return <button className={clsx(styles.button, styles[status], styles.button_text, className)} disabled={status != "normal"} {...rest} data-sentry-component="GradientButton" data-sentry-source-file="index.tsx">
      {status === "normal" && (children ?? translate(`${statusKey}_normal`))}
      {status != "normal" && <div className="flex items-center gap-2 justify-center">
          {status == "loading" && <CircularProgress aria-label="Loading..." color="secondary" classNames={{
        svg: "w-6 h-6"
      }} />}
          {status == "success" && <LottieAnimation src={getAnimation("success_button")} loop={false} autoplay={true} className="w-6 h-6" />}
          {status == "error" && <LottieAnimation src={getAnimation("error_button")} loop={false} autoplay={true} className="w-6 h-6" />}

          <span>
            {statusKey ? translate(`${statusKey}_${status}`) : rest[`${status}-message`] ?? translate(`button_${status}_message`)}
          </span>
        </div>}
    </button>;
}
export default GradientButton;